<template>
    <div class="form">
        <el-row style="margin-top: 20px;">
            <el-col :span="6">
                <el-tooltip class="item" content="患者初次就诊的日期" placement="top" :tabindex='-1'>
                    <el-form-item label="就诊日期" prop="form2.jiuzhenriqi" :class="$store.state.registration.form9.indexOf('form2_jiuzhenriqi') >= 0?'container':''">
                        <el-date-picker v-model="form2.jiuzhenriqi" value-format="yyyy-MM-dd" class="input"
                                        type="date" placeholder="选择日期" @change="handleAeg"></el-date-picker>
                    </el-form-item>
                </el-tooltip>
            </el-col>
            <el-col :span="6" v-show="showCOL">
                <el-tooltip class="item" content="患者就诊的年龄" placement="top" :tabindex='-1'>
                    <el-form-item label="就诊年龄" prop="form2.jiuzhennianling">
                        <el-input placeholder v-model="form2.jiuzhennianling" :disabled="true">
                        </el-input>
                    </el-form-item>
                </el-tooltip>
            </el-col>
            <el-col :span="6" v-show="showCOL">
                <el-tooltip class="item" content="患者就诊的医院" placement="top" :tabindex='-1'>
                    <el-form-item label="就诊医院" prop="form2.jiuzhenyiyuan">
                        <el-autocomplete
                                class="inline-input"
                                style="width:100%"
                                v-model="form2.jiuzhenyiyuan"
                                :fetch-suggestions="querySearch"
                                placeholder="就诊医院"
                                :trigger-on-focus="false"
                                @select="handleSelect"
                        ></el-autocomplete>
                    </el-form-item>
                </el-tooltip>
            </el-col>
        </el-row>
        <el-row style="margin-top: 20px;" v-show="showCOL">
            <el-col :span="6">
                <el-form-item label="" label-width="35px" prop="form2.alfenlei">
                    <div>
                        <el-tooltip
                                class="item"
                                content="既往无肿瘤、MDS等相关病史的初治急性白血病"
                                placement="top-start"
                        >
                            <el-radio :disabled="bingli?true:false" v-model="form2.alfenlei" label="初发急性白血病">初发急性白血病
                            </el-radio>
                        </el-tooltip>
                    </div>
                    <div>
                        <el-tooltip
                                class="item"
                                content="既往有相关病史，并接受细胞毒药物或放射治疗的急性白血病"
                                placement="top-start"
                                :tabindex='-10'
                        >
                            <el-radio :disabled="bingli?true:false" v-model="form2.alfenlei" label="治疗相关急性白血病">
                                治疗相关急性白血病
                            </el-radio>
                        </el-tooltip>
                    </div>
                    <div>
                        <el-tooltip
                                class="item"
                                content="伴多系病态造血AML包括既往有MDS病史，向AML发生转化；或无MDS病史，但骨髓有病态改变的AML"
                                placement="top-start"
                        >
                            <el-radio :disabled="bingli?true:false" v-model="form2.alfenlei" label="伴多系病态造血急性髓细胞白血病">
                                伴多系病态造血急性髓细胞白血病
                            </el-radio>
                        </el-tooltip>
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="16">
                <el-tooltip class="item" placement="top" :tabindex='-1'
                >
                    <div slot="content">
                        pro-B ALL ： CD10-<br/>
                        common-B ALL ： CD10+同时Cyμ-<br/>
                        pre-B ALL： Cyμ+<br/>
                        mature-B ALL：TdT-同时κ或λ轻链+
                    </div>
                    <el-form-item label="诊断分型" prop="form2.zhenduanfenxing">
                        <el-cascader
                                @change="updateFangan"
                                @focus="Fenfocus"
                                :options="zhenduanfenxing"
                                v-model="form2.zhenduanfenxing"
                                style="width: 50%"
                        ></el-cascader>
                    </el-form-item>
                </el-tooltip>
            </el-col>
        </el-row>
        <el-collapse @change="handleChange" v-model="activeNames">
            <el-collapse-item name="1" title="血常规" :tabindex='-1' v-show="showCOL">
                <el-row>
                    <el-col :span="5">
                        <el-tooltip class="item" content="白细胞" placement="top" :tabindex='-1'>
                            <el-form-item label="WBC" prop="form2.xuechanggui_wbc">
                                <el-input placeholder v-model="form2.xuechanggui_wbc"  oninput="if(isNaN(value)) { value = parseFloat(value)}if(isNaN(value)) { value = '' }">
                                  <span slot="append">
                                    x10
                                    <sup>9</sup>/L
                                  </span>
                                </el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="5">
                        <el-tooltip class="item" content="红细胞计数" placement="top" :tabindex='-1'>
                            <el-form-item label="RBC" prop="form2.xuechanggui_rbc">
                                <el-input placeholder v-model="form2.xuechanggui_rbc" oninput="if(isNaN(value)) { value = parseFloat(value)}if(isNaN(value)) { value = '' }">
                                    <span slot="append">
                                        x10
                                        <sup>12</sup>/L
                                    </span>
                                </el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="5">
                        <el-tooltip class="item" content="血红蛋白" placement="top" :tabindex='-1'>
                            <el-form-item label="Hb" prop="form2.xuechanggui_hb">
                                <el-input placeholder v-model="form2.xuechanggui_hb" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">g/L</span>
                                </el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="5">
                        <el-tooltip class="item" content="血小板" placement="top" :tabindex='-1'>
                            <el-form-item label="PLT" prop="form2.xuechanggui_plt">
                                <el-input placeholder v-model="form2.xuechanggui_plt" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">
                                        x10
                                        <sup>9</sup>/L
                                    </span>
                                </el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                </el-row>
            </el-collapse-item>
            <el-collapse-item name="4" title="出凝血指标" v-show="showCOL">
                <el-row>
                    <el-col :span="5">
                        <el-tooltip class="item" content="活化部分凝血活酶时间" placement="top" :tabindex='-1'>
                            <el-form-item label="APTT" prop="form2.chuningxuezhibiao_aptt">
                                <el-input placeholder v-model="form2.chuningxuezhibiao_aptt" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">s</span>
                                </el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="5">
                        <el-tooltip class="item" content="凝血酶原时间" placement="top" :tabindex='-1'>
                            <el-form-item label="PT" prop="form2.chuningxuezhibiao_pt">
                                <el-input placeholder v-model="form2.chuningxuezhibiao_pt" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">s</span>
                                </el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="5">
                        <el-tooltip class="item" content="凝血酶时间" placement="top" :tabindex='-1'>
                            <el-form-item label="TT" prop="form2.chuningxuezhibiao_tt">
                                <el-input placeholder v-model="form2.chuningxuezhibiao_tt" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">s</span>
                                </el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5">
                        <el-tooltip class="item" content="纤维蛋白原" placement="top" :tabindex='-1'>
                            <el-form-item label="FIB" prop="form2.chuningxuezhibiao_fib">
                                <el-input placeholder v-model="form2.chuningxuezhibiao_fib" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">g/L</span>
                                </el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="5">
                        <el-tooltip class="item" content="纤维蛋白（原）降解产物" placement="top" :tabindex='-1'>
                            <el-form-item label="FDP" prop="form2.chuningxuezhibiao_fdp">
                                <el-input placeholder v-model="form2.chuningxuezhibiao_fdp" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">mg/L</span>
                                </el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="5">
                        <el-tooltip class="item" content="D-二聚体" placement="top" :tabindex='-1'>
                            <el-form-item label="D-Dimmer" prop="form2.chuningxuezhibiao_d_dimmer">
                                <el-input placeholder v-model="form2.chuningxuezhibiao_d_dimmer" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">mg/L</span>
                                </el-input>
                            </el-form-item>
                        </el-tooltip>
                    </el-col>
                </el-row>
            </el-collapse-item>
            <el-collapse-item name="3" title="细胞形态">
                <el-row>
                    <el-tooltip class="item" placement="top" :tabindex='-1'>
                        <div slot="content">
                            患者治疗前的骨髓和外周血细胞形态学检查，原始细胞指白血病细胞，<br/><br/>包括AML中的原始粒细胞、M2b亚型中的异常中幼粒细胞、M3亚型中的异常早幼粒细胞、<br/><br/>
                            M5亚型中的原始单核细胞和幼稚单核细胞，M6亚型中的原始红细胞和幼稚红细胞<br/><br/>
                            以及ALL中的原始淋巴细胞和幼稚淋巴细胞。
                        </div>
                        <el-col :span="5">
                            <el-form-item label="骨髓原始细胞" label-width="110px" prop="form2.xibaoxingtai_gusuiyuanxibao">
                                <el-input placeholder v-model="form2.xibaoxingtai_gusuiyuanxibao" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }"
                                          :class="$store.state.registration.form9.indexOf('form2_xibaoxingtai_gusuiyuanxibao') >= 0?'container':''">
                                    <span slot="append">%</span>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-tooltip>
                    <el-col :span="5">
                        <el-form-item label label-width="55px" prop="fileList">
                            <el-upload ref="uploaddemo"
                                       class="upload-demo"
                                       action="/api/case/upload/"
                                       :headers="uploadHeader"
                                       :onSuccess="uploadSuccess"
                                       :on-preview="handlePreview"
                                       :on-remove="handleRemove"
                                       :file-list="form2.xibaoxingtai_guisuibaogaotupian"
                                       :before-remove="beforeRemove"
                                       :tabindex='-11'
                            >
                                <el-button type="primary" :tabindex='-11'>▲骨髓报告图片上传</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label-width="0px">
                            <el-button type="primary" @click="wmcode('linchuangxinxi_xibaoxingtai_guisuibaogaotupian')"
                                       :tabindex='-11'>▲扫二维码上传
                            </el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item
                                label="外周血原始细胞"
                                label-width="120px"
                                prop="xibaoxingtai_waizhouxuyuanshixibao"
                        >
                            <el-input placeholder v-model="form2.xibaoxingtai_waizhouxueyuanshixibao" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }"
                                      :class="$store.state.registration.form9.indexOf('form2_xibaoxingtai_waizhouxueyuanshixibao') >= 0?'container':''">
                                >
                                <span slot="append">%</span>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-collapse-item>
            <el-collapse-item name="2" title="功能状态(performance status)">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="ECOG评分">
                            <el-select
                                    placeholder="ECOG评分"
                                    style="width: 650px"
                                    v-model="form2.gongnengzhuangtai_ecog"
                            >
                                <el-option label="0 活动能力完全正常，与起病前活动能力无任何差异。" value="0"></el-option>
                                <el-option label="1 能自由走动及从事轻体力活动，包括一般家务或办公室工作，但不能从事较重的体力活动。" value="1"></el-option>
                                <el-option label="2 能自由走动及生活自理，但已丧失工作能力，日间不少于一半时间可以起床活动。" value="2"></el-option>
                                <el-option label="3 生活仅能部分自理，日间一半以上时间卧床或坐轮椅。" value="3"></el-option>
                                <el-option label="4 卧床不起，生活不能自理。" value="4"></el-option>
                                <el-option label="5 死亡" value="5"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-collapse-item>
            <el-collapse-item name="8" title="其他指标" v-show="showCOL">
                <el-collapse-item name="5" title="肝功能">
                    <el-row>
                        <el-col :span="5">
                            <el-tooltip class="item" content="ALT 谷丙转氨酶/丙氨酸氨基转移酶" placement="top" :tabindex='-1'>
                                <el-form-item label="ALT" prop="gangongneng_alt">
                                    <el-input placeholder v-model="form2.gangongneng_alt" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                        <span slot="append">IU/L</span>
                                    </el-input>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="5">
                            <el-tooltip class="item" content="AST 谷草转氨酶/天门冬氨酸氨基转移酶" placement="top" :tabindex='-1'>
                                <el-form-item label="AST" prop="gangongneng_ast">
                                    <el-input placeholder v-model="form2.gangongneng_ast" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                        <span slot="append">IU/L</span>
                                    </el-input>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="5">
                            <el-tooltip class="item" content="血清碱性磷酸酶" placement="top" :tabindex='-1'>
                                <el-form-item label="AKP" prop="gangongneng_akp">
                                    <el-input placeholder v-model="form2.gangongneng_akp" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                        <span slot="append">IU/L</span>
                                    </el-input>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="5">
                            <el-tooltip class="item" content="γ-谷氨酸转肽酶" placement="top" :tabindex='-1'>
                                <el-form-item label="GGT" prop="gangongneng_ggt">
                                    <el-input placeholder v-model="form2.gangongneng_ggt" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                        <span slot="append">IU/L</span>
                                    </el-input>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5">
                            <el-tooltip class="item" content="乳酸脱氢酶" placement="top" :tabindex='-1'>
                                <el-form-item label="LDH" prop="gangongneng_ldh">
                                    <el-input placeholder v-model="form2.gangongneng_ldh" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                        <span slot="append">IU/L</span>
                                    </el-input>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="5">
                            <el-tooltip class="item" content="总胆红素" placement="top" :tabindex='-1'>
                                <el-form-item label="TBIL" prop="gangongneng_tbil">
                                    <el-input placeholder v-model="form2.gangongneng_tbil" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                        <span slot="append">μmol/L</span>
                                    </el-input>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="5">
                            <el-tooltip class="item" content="直接胆红素" placement="top" :tabindex='-1'>
                                <el-form-item label="DBIL" prop="gangongneng_dbil">
                                    <el-input placeholder v-model="form2.gangongneng_dbil" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                        <span slot="append">μmol/L</span>
                                    </el-input>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="5">
                            <el-tooltip class="item" content="白蛋白" placement="top" :tabindex='-1'>
                                <el-form-item label="ALB" prop="gangongneng_alb">
                                    <el-input placeholder v-model="form2.gangongneng_alb" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                        <span slot="append">g/L</span>
                                    </el-input>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                    </el-row>
                </el-collapse-item>
                <el-collapse-item name="6" title="肾功能">
                    <el-row>
                        <el-col :span="5">
                            <el-tooltip class="item" content="血尿素氮" placement="top" :tabindex='-1'>
                                <el-form-item label="BUN" prop="shengongneng_bun">
                                    <el-input placeholder v-model="form2.shengongneng_alt" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                        <span slot="append">mmol/L</span>
                                    </el-input>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="5">
                            <el-tooltip class="item" content="血肌酐" placement="top" :tabindex='-1'>
                                <el-form-item label="CREA" prop="shengongneng_cr">
                                    <el-input placeholder v-model="form2.shengongneng_cr" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                        <span slot="append">μmol/L</span>
                                    </el-input>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="5">
                            <el-tooltip class="item" content="尿酸" placement="top" :tabindex='-1'>
                                <el-form-item label="UA" prop="shengongneng_ua">
                                    <el-input placeholder v-model="form2.shengongneng_ua" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                        <span slot="append">μmol/L</span>
                                    </el-input>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                    </el-row>
                </el-collapse-item>
                <el-collapse-item name="7" title="电解质">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="Na+" prop="dianjiezhi_na">
                                <span slot="label">
                                  Na
                                  <sup>+</sup>
                                </span>
                                <el-input placeholder v-model="form2.dianjiezhi_na" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">mmol/L</span>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="K+" prop="dianjiezhi_k">
                                <span slot="label">
                                  K
                                  <sup>+</sup>
                                </span>
                                <el-input placeholder v-model="form2.dianjiezhi_k" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">mmol/L</span>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="CI-" prop="dianjiezhi_ci">
                                <span slot="label">
                                  Cl
                                  <sup>-</sup>
                                </span>
                                <el-input placeholder v-model="form2.dianjiezhi_cl" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">mmol/L</span>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="CA++" prop="dianjiezhi_ca">
                                <span slot="label">
                                  Ca
                                  <sup>2+</sup>
                                </span>
                                <el-input placeholder v-model="form2.dianjiezhi_ca" oninput="if(isNaN(value)) { value = parseFloat(value) }if(isNaN(value)) { value = '' }">
                                    <span slot="append">mmol/L</span>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-collapse-item>
            </el-collapse-item>
        </el-collapse>
        <el-dialog
                title="扫二维码上传"
                :visible.sync="model"
                width="30%"
                :before-close="handleQrcode">
            <erweima id="linc" ref="linc"/>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleQrcode">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="预览" :visible.sync="dialogVisible" height="70%" append-to-body>
            <div>
                <img :src="imageUrl" width="100%;" :style="{transform:'rotateZ('+deg+'deg)'}">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="rotate">旋 转</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-alert title="指标说明: 血常规、出凝血指标、肝功能、肾功能、电解质、均指患者治疗前的检查指标。" type="warning" :closable="false"
                  show-icon></el-alert>
    </div>
</template>
<script>
    import zhenduanfenxing from "../../../config/zhenduanfenxing";
    import erweima from './widgets/erweima'

    export default {
        props: ["bingli", 'addedit', 'updateFlag'],
        components: {
            erweima
        },
        data() {
            let token = localStorage.getItem("token");
            return {
                groups: localStorage.getItem('groups'),
                model: false,
                deg: 0,
                restaurants: [],
                uploadHeader: {Authorization: `Bearer ${token}`},
                dialogVisible: false,
                imageUrl: "",
                activeName: "first",
                activeNames: ["1", "2", "3", "4", "5", "6", "7"],
                zhenduanfenxing: zhenduanfenxing,
                form2: this.$store.state.registration.form2,
                rules: {
                    jiuzhenriqi: [
                        {required: true, message: "请输入就诊日期", trigger: "blur"}
                    ],
                    jiuzhenyiyuan: [
                        {required: true, message: "请输入就诊医院", trigger: "blur"}
                    ],
                    zhenduanfenxing: [
                        {
                            type: "array",
                            required: true,
                            message: "请选择",
                            trigger: "change"
                        }
                    ]
                }
            };
        },
        computed: {
            showCOL() {
                if (this.updateFlag) {
                    if (this.groups == '5' || this.groups == '7') {
                        return false
                    }
                }
                return true
            }
        },
        methods: {
            checkData(value){
                if(value.indexOf(".") != -1 && value.split('.').length > 2){
                    return this.$message.warning('请输入正确格式的出价') //防止输入多个小数点
                }
            },
            rotate() {
                this.deg += 90;
                if (this.deg >= 360) {
                    this.deg = 0
                }
            },
            updateFangan() {
                this.$bus.$emit('shareText')
                this.$store.state.registration.form6.zhiliaofangan = {
                    "one": "",
                    "two": "",
                    "three": "",
                    "four": "",
                    "five": "",
                    "six": "",
                    "seven": '',
                    "other": ''
                }
            },
            handleQrcode() {
                this.model = false
                this.getimage('linchuangxinxi_xibaoxingtai_guisuibaogaotupian')
            },
            handleAeg() {
                var myDate;
                if (this.form2.jiuzhenriqi) {
                    myDate = new Date(this.form2.jiuzhenriqi.replace(/-/g, '/'));
                    var month = myDate.getMonth() + 1;
                    var day = myDate.getDate();
                    var UUserCard = this.$store.state.registration.form1.shenfenzheng;
                    var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
                    if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(12, 14) <= day) {
                        age++;
                    }
                    this.form2.jiuzhennianling = age
                }
            },
            Fenfocus(env) {
                console.log(env)
            },
            quchong(data) {
                var b = []
                var tem = data.concat(this.form2.xibaoxingtai_guisuibaogaotupian);
                var len = tem.length;
                var i = 0;
                var arr = [];
                for (; i < len; i++) {
                    var t = tem[i];
                    if (arr.indexOf(t['id']) == -1) {
                        arr.push(t['id']);
                        b.push(t);
                    }
                }
                return b
            },
            getimage(value) {
                this.$http.get(`/case/image/list/?filed=${value}&uid=${this.$store.state.registration.form1.uuid}`)
                    .then(resp => {
                        this.form2.xibaoxingtai_guisuibaogaotupian = this.quchong(resp.data.data)
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            },
            guid() {
                var that = this
                return (that.S4() + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + that.S4() + that.S4());
            },
            wmcode(value) {
                var that = this
                that.model = true
                if (!that.$store.state.registration.form1.uuid) {
                    that.$store.state.registration.form1.uuid = that.guid()
                }
                if (that.$store.state.registration.form1.uuid) {
                    var url = window.location.href.split('#')[0] + 'case/uploadsredoce/?field='
                    url = url + value + '&uuid=' + that.$store.state.registration.form1.uuid+ "&token=" + localStorage.getItem('token')
                    that.$nextTick(() => {
                        that.$refs.linc.useqrcode(url)
                    })
                } else {
                    that.$message({
                        message: '请先暂存数据，再刷新页面',
                        type: 'warning'
                    })
                }
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
                this.$store.state.registration.form2.xibaoxingtai_guisuibaogaotupian = fileList;
                this.$store.dispatch({
                    type: 'delImage',
                    pk: file.id,

                }).then(resp => {
                    if (resp.data.code == 1) {
                        this.$message({message: '删除成功！', type: 'success'})
                    } else if (resp.data.code == -1) {
                        this.$message({message: resp.data.errors, type: 'error'})
                    }
                });
            },
            handlePreview(e) {
                // console.log(e);
                var name = e.url.split('.').pop()
                if (name == "pdf") {
                    window.open(window.location.href.split('#')[0] + e.url.slice(1), "_blank");
                } else if (name == "png" || name == "jpeg" || name == "bmp" || name == "jpg") {
                    // this.dialogVisible = true
                    // this.imageUrl = e.url
                    window.open(window.location.href.split('#')[0] + e.url.slice(1), "_blank");
                } else {
                    window.location = window.location.href.split('#')[0] + e.url.slice(1)
                }
            },
            handleChange() {
            },
            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString
                    ? restaurants.filter(this.createFilter(queryString))
                    : restaurants;
                cb(results);
            },
            createFilter(queryString) {
                return restaurant => {
                    return (
                        restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
                    );
                };
            },
            handleSelect(item) {
                console.log(item);
            },
            uploadSuccess(response, file) {
                this.$store.state.registration.form2.xibaoxingtai_guisuibaogaotupian.push(file.response);
            },
        },
        mounted() {
            if (this.addedit == 0) {
                this.$store.state.registration.form2.xibaoxingtai_guisuibaogaotupian = []
                this.$refs.uploaddemo.clearFiles();
            }
        }
    };
</script>

<style scoped>
    .input {
        width: 100%;
    }

    .form /deep/ .el-collapse-item__arrow {
        margin: 0px 8px 0 10px;
    }

    .form /deep/ .el-input-group__append,
    .form /deep/ .el-input-group__prepend {
        width: 40px;
        padding: 0 5px;
        font-size: 10px;
        overflow: hidden;
        text-align: center;
        background-color: #f7f7f8;
    }

    .form /deep/ .el-form-item__label {
        font-size: 13px;
    }

    .form /deep/ .el-collapse-item__header {
        font-size: 14px;
        color: #3a8ee6;
    }

    .container /deep/ .el-input__inner {
        color: red;
    }
</style>
